class deductionRuleCtrl {
    constructor($scope, httpRequest,$uibModalInstance, logger, sweetalert) {
        const types = ['ivat_inv_type']
        $scope.deductionType = [{enumCode:'1',enumName:'抵扣勾选'},{enumCode:'2',enumName:'计算抵扣'}]
        $scope.deductionFlag = [{enumCode:'0',enumName:'不允许'},{enumCode:'1',enumName:'允许'}]
        $scope.smnCompareRule = [{enumCode:'0',enumName:'等于'},{enumCode:'1',enumName:'包含'},{enumCode:'2',enumName:'不包含'}]
        $scope.mnCompareRule = [{enumCode:'0',enumName:'等于'},{enumCode:'1',enumName:'包含'},{enumCode:'2',enumName:'不包含'}]
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.param = {
            shemeId: 0,
            invoiceType: '',
            deductionFlag: '',
            dkbzId: '',
            shortAndMatName: '',
            smnCompareRule: -1,
            matName: '',
            mnCompareRule: -1
        }
        $scope.schemes = []
        httpRequest.post_queryDeductionScheme().then((res) => {
            $scope.datas = res.data.value.list
            if($scope.datas){
                $scope.datas.forEach((item) => {
                    const it = {enumCode: item.id,enumName:item.schemeName}
                    $scope.schemes.push(it)
                })
            }
        })
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function ok() {
            httpRequest.post_addDeductionSchemeRule($scope.param).then((res) => {
                if(res.data && res.data.success){
                    $uibModalInstance.close()
                }else{
                    logger.logError(res.data.message)
                }
            })

        }
    }
}

deductionRuleCtrl.$inject = ['$scope', 'httpRequest','$uibModalInstance', 'logger', 'sweetalert']

export default deductionRuleCtrl



// WEBPACK FOOTER //
// ./src/app/input/basedata/deductionConfig/deductionRuleCtrl.js